module.exports = __webpack_public_path__ + "img/D.15de0c35.jpg";